var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 81,
    viewBox: "0 0 134 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.224,
    cy: 2.61882,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.7548,
    cy: 2.61882,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2853,
    cy: 2.61882,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8156,
    cy: 2.61882,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.346,
    cy: 2.61882,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.877,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1633,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6935,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.224,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.755,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2853,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8156,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.346,
    cy: 17.652,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.877,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1633,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6935,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.224,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.755,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2853,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8156,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.346,
    cy: 47.7204,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6662,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7006,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7343,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.7682,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.8022,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8361,
    cy: 77.7886,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6528,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.61882,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.897,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6799,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7072,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7343,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7614,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7887,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8156,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.843,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.87,
    cy: 32.6872,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.63249,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.407,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1633,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6935,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.224,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.755,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2853,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8156,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.346,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.877,
    cy: 62.7555,
    r: 2.61882,
    fill: "#FF934F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDots);
export default __webpack_public_path__ + "static/media/orange-dots.e7b19eb0ed3cb70a5f445766c862d7dd.svg";
export { ForwardRef as ReactComponent };